import { FC } from 'react'
import { View } from './View'
import PageHeader from 'components/account/PageHeader'
import Grid from '@mui/material/Grid'
import cx from 'classnames'
import ContainedButton from 'components/search/ContainedButton'
import url from 'libraries/front-end-core/core/url'
import { USER_ADMIN } from 'constants/controllers'

interface Props {
  view: View
  aol: string
}
const views: Array<{ view: View, title: string }> = [
  { view: View.ADD_USERS, title: 'Add Users' },
  { view: View.DELETE_USERS, title: 'Delete Users' },
  { view: View.EDIT_USERS, title: 'Edit Users' }
]
const Navigation: FC<Props> = ({ view: pageView, aol }) => (
  <div className='mt6-m mt6-t mt8'>
    <span className='dn-m'><PageHeader margin='mt2 mb7' title='User Management' /></span>
    <Grid container spacing={1}>
      {views.map(({ view, title }) => (
        <Grid item xs={12} sm={4} md={12} key={view}>
          <NavigationItem {...{ view, title, aol }} active={view === pageView} />
        </Grid>
      ))}
    </Grid>
  </div>
)

interface ItemProps {
  view: View
  title: string
  active: boolean
  aol: string
}

const NavigationItem: FC<ItemProps> = ({ view, title, active, aol }) => (
  <div
    className={cx('f5 ds outline-0', {
      grey: !active,
      'dark-cyan': active
    })}
    data-event-category='User Management'
    data-event-action='View'
    data-event-label={title}
  >
    <ContainedButton
      title={title}
      selected={active}
      iconName={null}
      hideIcon
      href={!active ? url(USER_ADMIN, { view, aol }) : null}
      buttonCxNames={cx('ttc b f5', {
        'bg-white ba b--cadet-blue': !active,
        'account-nav-button': active
      })}
    />
  </div>
)

export default Navigation
